<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  mounted () { }
}
</script>

<style>
body {
  background-color: transparent;
}
</style>
